import { ProgramCard } from './ProgramCard'
import type { Program } from '../../types/database.types'
import type { AssignmentSummary } from '../../services/assignmentService'

interface ProgramListProps {
  programs: (Program & { item_count?: number; total_duration?: number })[]
  assignmentSummaries?: Map<string, AssignmentSummary>
  isLoading?: boolean
  onDeleteProgram?: (program: Program) => void
  onDuplicateProgram?: (program: Program) => void
  onToggleTemplate?: (program: Program) => void
  onUseTemplate?: (program: Program) => void
  onToggleVisibility?: (program: Program) => void
  togglingVisibilityId?: string | null
  emptyMessage?: string
}

export function ProgramList({
  programs,
  assignmentSummaries,
  isLoading = false,
  onDeleteProgram,
  onDuplicateProgram,
  onToggleTemplate,
  onUseTemplate,
  onToggleVisibility,
  togglingVisibilityId,
  emptyMessage = 'No programs found',
}: ProgramListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-200 rounded-xl h-48" />
          </div>
        ))}
      </div>
    )
  }

  if (programs.length === 0) {
    return (
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
        <p className="mt-4 text-gray-600">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {programs.map((program) => (
        <ProgramCard
          key={program.id}
          program={program}
          assignmentSummary={assignmentSummaries?.get(program.id)}
          onDelete={
            onDeleteProgram ? () => onDeleteProgram(program) : undefined
          }
          onDuplicate={
            onDuplicateProgram ? () => onDuplicateProgram(program) : undefined
          }
          onToggleTemplate={
            onToggleTemplate ? () => onToggleTemplate(program) : undefined
          }
          onUseTemplate={
            onUseTemplate ? () => onUseTemplate(program) : undefined
          }
          onToggleVisibility={
            onToggleVisibility ? () => onToggleVisibility(program) : undefined
          }
          isTogglingVisibility={togglingVisibilityId === program.id}
        />
      ))}
    </div>
  )
}
